
import React from "react";
import { Tweet } from 'react-tweet'

const TwitterCard = ({ item, styles }) => {
  const coloum_value = JSON.parse(item?.coloum_value);

  function extractTweetIdFromUrl(tweetUrl) {
    // Split the URL by '/'
    const urlParts = tweetUrl.split('/');
    
    // Find the segment that contains 'status'
    const statusSegmentIndex = urlParts.indexOf('status');
    
    // The Tweet ID is usually the segment after 'status'
    if (statusSegmentIndex !== -1 && statusSegmentIndex < urlParts.length - 1) {
      const tweetId = urlParts[statusSegmentIndex + 1];
      return tweetId;
    }
  
    return null;
  }
  const tweetId = extractTweetIdFromUrl(coloum_value?.coloum_value);

  return (
    <div className="w-full justify-center light flex">
      <Tweet id={tweetId} />
      </div>
  );
};

export default TwitterCard;
